import { cn } from 'noddi-ui-common';
import * as React from 'react';
import { NoddiTooltip } from '../Overlay/NoddiTooltip';

const NoddiTextArea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & {
    label?: string;
    tooltip?: string;
  }
>(({ className, label, tooltip, ...props }, ref) => {
  const generatedId = React.useId();
  const controlId = props.id ?? props.name ?? generatedId;
  const labelIdentifier = `${controlId}-label`;

  return (
    <div className='flex flex-col gap-0.5'>
      {label && (
        <div className='flex items-center gap-2'>
          <label className='text-sm' id={labelIdentifier} htmlFor={controlId}>
            {label}
          </label>
          {tooltip && <NoddiTooltip content={tooltip} label={`More information about ${label}`} />}
        </div>
      )}
      <textarea
        id={controlId}
        className={cn(
          'flex min-h-15 w-full min-w-70 rounded-md border border-input bg-white px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
NoddiTextArea.displayName = 'NoddiTextArea';

export { NoddiTextArea };
